import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MessageStatus } from '../models/message-status.model';

@Injectable({
  providedIn: 'root'
})
export class MessageStatusService {

  constructor(private httpClient: HttpClient) { }

  getMessageStatus() : Observable<MessageStatus[]> {
    return this.httpClient.get<MessageStatus[]>('assets/components/message-status/message-status.json').pipe(
      map(data => data)
    );
  }
}
